import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { getApi } from '../../api/bootstrap';
import { Button } from '../../components/Button';
import { PiePagina } from '../../components/PiePagina';
import { ErrorMessage } from '../../components/ErrorMessage';
import { Input } from '../../components/Input';
import { Logo } from '../../components/Logo';
import { Spinner } from '../../components/Spinner';
import { formatError } from '../../lib/formatError';
import { useAuthStore } from '../../stores/authStore';

const FormSchema = z.object({
  identificador: z.string().min(1, 'Requerido'),
  clave: z.string().min(1, 'Requerido'),
});
type FormData = z.infer<typeof FormSchema>;

export function LoginPage() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: { identificador: '', clave: '' },
  });

  const mutation = useMutation({
    mutationFn: (data: FormData) => getApi().authClient.login(data),
    onSuccess: (response) => {
      if (response.tipo === 'token_directo') {
        useAuthStore.getState().setSession({
          token: response.tokenResponse.access_token,
          tipoToken: response.tokenResponse.tipo,
          locale: response.tokenResponse.locale,
          tenantNombre: response.tokenResponse.tenant_nombre,
          usuarioNombre: response.tokenResponse.usuario_nombre,
        });
        navigate('/mi-simulacion', { replace: true });
      } else if (response.tipo === 'seleccion_requerida') {
        navigate('/tenant', {
          state: { selectorToken: response.selectorToken, tenants: response.tenants },
        });
      } else {
        navigate('/2fa', { state: { otpToken: response.otpToken } });
      }
    },
  });

  return (
    <main className="flex min-h-screen flex-col bg-slate-50 px-4">
      <div className="flex flex-1 items-center justify-center py-6">
        <div className="w-full max-w-sm space-y-6 rounded-2xl bg-white p-6 shadow-sm sm:p-8">
          <div className="flex flex-col items-center gap-3 text-center">
            <Logo className="h-20" />
            <h1 className="text-xl font-semibold text-slate-900">
              Paciente simulado estandarizado
            </h1>
          </div>
          <form
            onSubmit={handleSubmit((data) => mutation.mutate(data))}
            className="space-y-4"
            noValidate
          >
            <Input
              label="Identificador"
              type="text"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              {...register('identificador')}
              error={errors.identificador?.message}
            />
            <Input
              label="Contraseña"
              type="password"
              autoComplete="current-password"
              {...register('clave')}
              error={errors.clave?.message}
            />
            {mutation.isError && (
              <ErrorMessage>{formatError(mutation.error, 'login')}</ErrorMessage>
            )}
            <Button type="submit" disabled={mutation.isPending} className="w-full">
              {mutation.isPending ? <Spinner /> : 'Ingresar'}
            </Button>
          </form>
        </div>
      </div>
      <PiePagina />
    </main>
  );
}
